/**
 * Company Contractor roster data access.
 *
 * Contractor records belong to the Company and are managed in Settings.
 * Booking-specific crew selection remains in event-workspace-api.
 */
import { apiFetch } from "../../../shared/api-client";

export interface Contractor {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  skills: string[];
  bank_account?: string | null;
  /** Default job sheet template; null = inherit the Company default (#188). */
  jobsheet_template_id?: string | null;
}

export interface ContractorPayload {
  id?: string;
  name: string;
  email: string;
  phone: string | null;
  skills: string[] | null;
  bank_account: string | null;
  jobsheet_template_id?: string | null;
}

/** List the active Company roster, ordered by name. */
export async function listContractors(
  signal?: AbortSignal,
): Promise<Contractor[]> {
  const res = await apiFetch<{ contractors: Contractor[] }>(
    "/api/admin/contractors",
    { signal },
  );
  return res.contractors ?? [];
}

/** Create or update a Company Contractor. */
export async function saveContractor(
  payload: ContractorPayload,
): Promise<Contractor> {
  const res = await apiFetch<{ contractor: Contractor }>(
    "/api/admin/contractors",
    {
      method: payload.id ? "PATCH" : "POST",
      body: payload,
    },
  );
  return res.contractor;
}

/** Soft-delete a Contractor from the active Company roster. */
export async function deleteContractor(id: string): Promise<void> {
  await apiFetch<void>("/api/admin/contractors", {
    method: "DELETE",
    query: { id },
  });
}
